/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";

import { setSelectedModuleID } from "redux/slice/uploadFileModule";
import { useDispatch } from "react-redux";

export function SidebarLinks(props) {
  //   Chakra color mode
  const dispatch = useDispatch();

  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes, moduleAccordian } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName, module_id) => {
    const module_type_id = new URLSearchParams(location.search).get("id");
    const url = new URL(routeName, window.location.href);
    const pathWithoutQuery = url.pathname;
    if (module_id === null) {
      return location.pathname.includes(routeName);
    } else {
      if (
        location.pathname.includes(pathWithoutQuery) &&
        parseInt(module_type_id) === module_id
      ) {
        dispatch(setSelectedModuleID(module_id));
      }
      return (
        location.pathname.includes(pathWithoutQuery) &&
        parseInt(module_type_id) === module_id
      );
    }
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      return (
        <>
          {index === 2 ? moduleAccordian() : <></>}
          <NavLink key={index} to={route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase(), route.module)
                      ? "22px"
                      : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  {route.name === "Health Care" ||
                  route.name === "Private Health Services Plan Agreement" ||
                  route.name === "US Driver License Parser" ? (
                    <>
                      <Flex
                        w="100%"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Box color={activeColor} me="18px">
                          {route.icon}
                        </Box>
                        <Text me="auto" color={activeColor} fontWeight="normal">
                          {route.name}
                        </Text>
                      </Flex>
                      <Box
                        h="36px"
                        w="4px"
                        bg={"transparent"}
                        borderRadius="5px"
                      />
                    </>
                  ) : (
                    <>
                      <Flex
                        w="100%"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Box
                          color={
                            activeRoute(route.path.toLowerCase(), route.module)
                              ? activeIcon
                              : textColor
                          }
                          me="18px"
                        >
                          {route.icon}
                        </Box>
                        <Text
                          me="auto"
                          color={
                            activeRoute(route.path.toLowerCase(), route.module)
                              ? activeColor
                              : textColor
                          }
                          fontWeight={
                            activeRoute(route.path.toLowerCase(), route.module)
                              ? "bold"
                              : "normal"
                          }
                        >
                          {route.name}
                        </Text>
                      </Flex>
                      <Box
                        h="36px"
                        w="4px"
                        bg={
                          activeRoute(route.path.toLowerCase(), route.module)
                            ? brandColor
                            : "transparent"
                        }
                        borderRadius="5px"
                      />
                    </>
                  )}
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase(), route.module)
                      ? "22px"
                      : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase(), route.module)
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase(), route.module)
                        ? "bold"
                        : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        </>
      );
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
